<div class="flex flex-col">
  <div class="flex flex-row">
    <span class="font-semibold py-2">{{item()['chargennummer']}}</span>
  </div>
</div>
